<script setup lang="ts">
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();

    const productItems = computed(
        () =>
            orderStore.options.products
                .map((product) => {
                    const priceItem = orderStore.meta.pricelist[product.id];

                    if (!priceItem || !priceItem.active) {
                        return undefined;
                    }

                    const amount = orderStore.currentOrder.products.find(
                        (p) => p.id === product.id,
                    )?.amount;

                    return {
                        id: product.id,
                        title: `${product.label} - ${formatPrice(priceItem.price)}`,
                        subtitle: product.description,
                        amount,
                    };
                })
                .filter((product) => product !== undefined) as Array<{
                readonly id: number;
                readonly title: string;
                readonly subtitle: string;
                amount: number;
            }>,
    );
</script>

<template>
    <VTable>
        <thead>
            <tr class="text-subtitle-2">
                <th>Product</th>
                <th class="text-right">Hoeveelheid</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="product in productItems" :key="product.id">
                <td :id="`product-label-${product.id}`">
                    {{ product.title }}
                </td>
                <td style="width: 8rem" class="pa-0">
                    <VNumberInput
                        :model-value="product.amount"
                        :aria-labelledby="`product-label-${product.id}`"
                        variant="outlined"
                        :min="0"
                        density="compact"
                        hide-details="auto"
                        @update:model-value="
                            (value) =>
                                orderStore.helpers.setProduct(product.id, value)
                        "
                    />
                </td>
            </tr>
        </tbody>
    </VTable>
</template>
